import React, { useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import * as actions from '../actions/complaintandfeedbackactions'
import WhistleBlowing from '../components/WhistleBlowing';

export default function WhistleBlowingMaster() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const state = useSelector(state => state.complaintandfeedbackReducer);
    //let modalsState = state.modalsState;

    useEffect(() => {
        
             dispatch(actions.getSharedComplaintsMasters());
       
    }, []);
   
    return (
        <>
            <div class="container d-flex justify-content-center min-vh-100">

                    <WhistleBlowing />

            </div>
           
        </>
    )
}